import { render, staticRenderFns } from "./SaleDetailBrowse.vue?vue&type=template&id=6310bb16&scoped=true"
import script from "./SaleDetailBrowse.vue?vue&type=script&lang=ts"
export * from "./SaleDetailBrowse.vue?vue&type=script&lang=ts"
import style0 from "./SaleDetailBrowse.vue?vue&type=style&index=0&id=6310bb16&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6310bb16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6310bb16')) {
      api.createRecord('6310bb16', component.options)
    } else {
      api.reload('6310bb16', component.options)
    }
    module.hot.accept("./SaleDetailBrowse.vue?vue&type=template&id=6310bb16&scoped=true", function () {
      api.rerender('6310bb16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleDetailBrowse.vue"
export default component.exports